import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FunctionsHelper } from 'src/app/helpers/functions';
import * as Papa from 'papaparse';
import { BehaviorSubject, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductDetailsService {
  changesSubject = new BehaviorSubject<boolean>(false);
  watchChanges = this.changesSubject.asObservable();

  newAnalysisFile: File | null = null;

  fileColumns: string[] = [];
  fileRows: any[] = [];

  productIdColumnIndex: number | null = null;
  selectedIdentifier: string | null = null;
  identifierColumnIndex: number | null = null;

  CUSTOM_IDENTIFIER_TYPE: string = 'custom';

  constructor(
    private http: HttpClient,
    private _functionsHelper: FunctionsHelper
  ) { }

  changesMade() {
    this.changesSubject.next(true);
  }

  fetchFileRows = () => {
    return new Promise<void>((resolve, reject) => {
      if (this.newAnalysisFile === null) {
        reject('fileNotSelected');
        return;
      }

      this._functionsHelper.readCSVFile(this.newAnalysisFile).then((rows) => {
        this.fileColumns = rows[0];
        this.fileRows = rows.slice(1, rows.length);
        resolve();
      }, (err) => {
        reject(err);
      });
    });
  };

  uploadCsv = (params: any) => {
    params.apiType = 'PRODUCTS_DETAILS';

    const formData: FormData = this.prepareFinalCsvData();
    return this.http.post('/v4/bulk-api/job/uploadCsv', formData, { params });
  };

  prepareFinalCsvData = (): FormData => {
    const newCsvArrData: any[] = [];

    const columns: string[] = ['productId'];
    if (this.identifierColumnIndex !== null) {
      columns.push('idType');
    }

    const allValues: string[] = [];

    newCsvArrData.push(columns);
    this.fileRows.map(row => {
      const newRow: any[] = [];
      if (this.productIdColumnIndex !== null) {
        const identifierValue = row[this.productIdColumnIndex].toString().replace(/\s/g, '');
        if (!allValues.includes(identifierValue)) {
          allValues.push(identifierValue);
          newRow.push(identifierValue);
          if (this.identifierColumnIndex !== null) {
            const identifierType = row[this.identifierColumnIndex].toString().replace(/\s/g, '').toUpperCase();
            newRow.push(identifierType);
          }
        }
      }
      if (newRow.length > 0) newCsvArrData.push(newRow);
    });
    console.log('CSV Rows sent to Backend API', newCsvArrData.length);
    // console.log('New Data from User\'s CSV', newCsvArrData);
    // console.log('New Data from User\'s CSV', newCsvArrData.splice(0, 10));

    const csvData = Papa.unparse(newCsvArrData);
    const blob = new Blob([csvData], { type: 'text/csv' });

    const formData = new FormData();
    formData.append('file', blob, this._functionsHelper.removeFileExtension(this.newAnalysisFile?.name as string) + '.csv');

    return formData;
  };

  getAdditionalAttributes(categoryIds: string, search: string, limit: number = 10) {
    return this.http.get('v4/bulk-api/job/attribute/names', {
      params: {
        categoryIds: categoryIds.replace(' ', ''),
        name: search,
        limit
      }
    }).pipe(
      map((resp: any): string[] => {
        if (resp.statusCode === 200 && resp.result && resp.result.attributeNames) {
          return resp.result.attributeNames;
        }
        return [];
      })
    );
  }

}

